import { render } from "./ExternalPatientChangePasswordOffcanvas.vue?vue&type=template&id=44b796b0&scoped=true"
import script from "./ExternalPatientChangePasswordOffcanvas.vue?vue&type=script&lang=js"
export * from "./ExternalPatientChangePasswordOffcanvas.vue?vue&type=script&lang=js"

import "./ExternalPatientChangePasswordOffcanvas.vue?vue&type=style&index=0&id=44b796b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44b796b0"]])

export default __exports__